/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_YesInputs */

const en_cmp_yes = /** @type {(inputs: Cmp_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const id_cmp_yes = /** @type {(inputs: Cmp_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Cmp_YesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_yes = /** @type {((inputs?: Cmp_YesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_YesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_yes(inputs)
	return en_cmp_yes(inputs)
});